module.exports = __webpack_public_path__ + "img/black-tap.e1decc94.jpg";